import React from "react";

import { AccountNavigationMdUp } from "./account-navigation-md";
import { AccountNavigationXs } from "./account-navigation-xs";

export type Page =
  | "trips"
  | "trip_details"
  | "passengers"
  | "settings"
  | "loyalty_profile";

export interface Props {
  current_page: Page;
}

export const AccountNavigation: React.FC<Props> = ({ current_page }) => (
  <>
    <AccountNavigationMdUp current_page={current_page} />
    <AccountNavigationXs current_page={current_page} />
  </>
);
